import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, DocumentMayBeRequiredIcon, Grid, Text } from '@common-fe/common-fe';

interface Props {
  isMobile?: boolean;
  onUploadDocument?: () => void;
  onSkipUploadDocument?: () => void;
}

const DocumentMayBeRequiredWarning: React.FC<Props> = ({
  isMobile,
  onUploadDocument,
  onSkipUploadDocument,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      data-testid="document-may-be-required-warning"
      pad="spacing16"
      round="container1Round"
      background="missingContainer"
    >
      <Box direction="row" align="center" gap="spacing12">
        <DocumentMayBeRequiredIcon size="80px" />
        <Box flex>
          <Text data-testid="document-may-be-required-warning_title" weight={700}>
            {t('Document may be required')}
          </Text>
          <Text data-testid="document-may-be-required-warning_description" margin={{ top: 'spacing2' }}>
            {t(
              'Depending on the date and type of service, your plan may require supporting documentation to approve this expense.'
            )}
          </Text>
          <Text data-testid="document-may-be-required-warning_additional-info" margin={{ top: 'spacing8' }}>
            {t(
              "To receive your money faster, add your documentation now. If you don't have it available, you can always add it later. "
            )}
          </Text>
        </Box>
      </Box>

      <Grid
        margin={{ top: 'spacing16' }}
        width="100%"
        gap="spacing16"
        columns={isMobile ? ['1fr'] : ['1fr', '1fr']}
      >
        <AppButton testId="document-may-be-required-warning_upload" onClick={onUploadDocument} width="100%">
          {t('Upload Document')}
        </AppButton>
        <AppButton
          testId="document-may-be-required-warning_skip"
          onClick={onSkipUploadDocument}
          buttonType="secondary"
          width="100%"
        >
          {t('Continue Without Document')}
        </AppButton>
      </Grid>
    </Box>
  );
};

export default DocumentMayBeRequiredWarning;
